import styled from '@emotion/styled'
import { colors, layering, measurements, spacing } from '@mobi/component-library/Foundations'
import { hexColors } from '@mobi/settings'
import { Heading } from '@core/Components/Text/Heading'

export const MysteryBetContainerStyled = styled.div({
  flex: 1,
  padding: `${spacing.sm} ${spacing.md}`,
  paddingBottom: `calc(${measurements.mobi.bottomTabsHeight} + 10rem)`,
})

export const MysteryHeadingStyled = styled(Heading)({
  margin: '0 0 1rem 0',
  fontSize: '1.4rem',
  lineHeight: '1.6rem',
  color: colors.black,
})

export const FullScreenOverlayContainerStyled = styled.div({
  position: 'fixed',
  display: 'flex',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: layering.appHeader + 1,
  overflowY: 'auto',
  overscrollBehaviorY: 'contain',
  backgroundColor: hexColors.whiteSmoke,
})

export const FullScreenContentsStyled = styled.div({
  position: 'relative',
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: measurements.mobi.maxWidth,
  width: `min(100vw, ${measurements.mobi.maxWidth})`,
})

export const FullScreenTopSectionStyled = styled.div({
  backgroundColor: hexColors.blueDiamond,
  color: hexColors.white,
  padding: '1rem',
  '#mystery-meeting-name-and-race-number': {
    fontSize: '1.6rem',
    fontWeight: 'bold',
  },
  '#mystery-bet-type, #mystery-bet-betting-closed': {
    backgroundColor: hexColors.darkPurple,
    padding: '0 1em',
    fontWeight: 'bold',
    fontSize: '1.4rem',
  },
  '#mystery-bet-countdown': {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    backgroundColor: hexColors.darkPurple,
    padding: '0 1em',
  },
})

export const CustomizeSpendInputContainerStyled = styled.div<{
  infoText: string
  isSelected: boolean
}>(({ infoText, isSelected }) => ({
  position: 'relative',
  color: isSelected ? hexColors.blueDiamond : hexColors.white,
  '&:before': {
    content: infoText ? `"${infoText}"` : undefined,
    position: 'absolute',
    display: 'inline-block',
    left: '1rem',
    top: '33.33%',
    bottom: 0,
    pointerEvents: 'none',
    fontSize: '1.4rem',
    fontWeight: 'normal',
    verticalAlign: 'middle',
    zIndex: 1,
  },
}))

interface CustomizeSpendInputStyledProps {
  isSelected: boolean
}

export const CustomizeSpendInputStyled = styled.button<CustomizeSpendInputStyledProps>(
  {
    backgroundColor: 'rgba(255,255,255,0.12)',
    color: 'inherit',
    border: 'none',
    fontSize: '2.2rem',
    fontWeight: 'bold',
    padding: '1.6rem 1rem 1.6rem 5rem',
    textAlign: 'right',
    width: '100%',
  },
  ({ isSelected }) => ({
    backgroundColor: isSelected ? hexColors.white : 'rgba(255,255,255,0.12)',
    color: isSelected ? hexColors.blueDiamond : hexColors.white,
    outline: 'none',
  })
)

export const BiggerTextStyled = styled.div({
  fontSize: '1.4rem',
})

export const MysteryBetCloseButtonStyled = styled.button({
  position: 'absolute',
  top: 0,
  right: 0,
  width: '5.5rem',
  height: '4rem',
  padding: 0,
  border: 0,
  backgroundColor: 'transparent',
  fontSize: '1.6rem',
  color: hexColors.white,
})
